import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {FuelPriceIndexType} from "../types";

@Injectable({
  providedIn: 'root',
})
export class FuelPriceIndexTypeService {
  private readonly baseUrl = '/api/dictionary/fuel-price-index-type';

  constructor(private http: HttpClient) {}

  getFuelPriceIndexTypeById(id: number): Observable<FuelPriceIndexType[]> {
    return this.http.get<FuelPriceIndexType[]>(`${this.baseUrl}`, {
      params: { id: id.toString() },
    });
  }

  getAll(): Observable<FuelPriceIndexType[]> {
    return this.http.get<FuelPriceIndexType[]>(this.baseUrl);
  }
}
